import { ICategoryWithChildren } from 'src/components/MenuSectionItems/utilities';
import { IMenuItem } from 'src/types/menu.types';

export const getPromptText = (name: string, items: IMenuItem[], subcategories: ICategoryWithChildren[]) => {
  if (subcategories.length)
    return 'All items within this category and its subcategories will be moved to the "Uncategorised" menu category. All subcategories will be deleted. This action cannot be undone.';
  if (items.length) return 'All products will be moved to the "Uncategorised" menu category.';
  return `This will permanently delete ${name}.`;
};
